import { ResizeOptions, ResizePosition } from "./resize/types";
import { WidgetPos } from "../types";
import { getResizePositions } from "./resize/getResizePositions";
import { getWidgetSizeWorklet } from "./getWidgetSize";
import { SharedValue, useDerivedValue } from "react-native-reanimated";

export function useResizeOptions({
  thisWidget,
  widgets,
  isResizable,
  numberOfRows,
}: {
  thisWidget: SharedValue<WidgetPos>;
  widgets: SharedValue<WidgetPos[]>;
  isResizable: boolean;
  numberOfRows: number;
}) {
  const possibleSizes = useDerivedValue(() =>
    getWidgetSizeWorklet(thisWidget.value)
  );

  const resizeOptions = useDerivedValue(
    (): Record<ResizePosition, ResizeOptions> => {
      if (!isResizable || possibleSizes.value.length === 0) {
        return {
          bottom: { collapse: false, expand: 0 },
          left: { collapse: false, expand: 0 },
          right: { collapse: false, expand: 0 },
          top: { collapse: false, expand: 0 },
        };
      }
      if (thisWidget.value.id === "init") {
        return {
          bottom: { collapse: false, expand: 0 },
          left: { collapse: false, expand: 0 },
          right: { collapse: false, expand: 0 },
          top: { collapse: false, expand: 0 },
        };
      }
      return getResizePositions(
        thisWidget.value,
        widgets.value,
        possibleSizes.value,
        numberOfRows
      );
    }
  );
  return [resizeOptions, possibleSizes] as const;
}
